// Template248: Bélgica - Día 1 Mapa Bruselas (Page4Mapa.jsx)
// Iframe Google Maps Día 1 Bruselas + sticker + tip + texto explicación. Cabecera #D4A017.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template248 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const tipText = page?.texts?.[1]?.content;
	const footerText = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div style={{ padding: "10px", textAlign: "right", backgroundColor: actualHeaderColor }}>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe title="Mapa grande Bruselas" src={mapUrl} width="100%" height="100%" style={{ border: 0, flex: 1 }} allowFullScreen loading="lazy" />
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": { fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important` },
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					zIndex: 2,
					position: "relative",
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box component="img" src={logoImage} alt="logo" sx={{ width: 80, position: "absolute", right: 2, top: 18, zIndex: 999999 }} />
				)}
			</Box>

			<Box data-block-id="map" sx={{ flex: 1, marginTop: "-70px", position: "relative", minHeight: 280 }}>
				{mapUrl && (
					<>
						<button
							onClick={() => setFullscreen(true)}
							style={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: actualHeaderColor,
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								fontFamily: "'Poppins', sans-serif",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</button>
						<iframe title="Mapa Bruselas centro" src={mapUrl} width="100%" height="100%" style={{ border: 0, minHeight: 280 }} loading="lazy" />
					</>
				)}

				{stickerImage && (
					<Box component="img" src={stickerImage} alt="" sx={{ width: 110, position: "absolute", bottom: -10, left: -20, zIndex: 5 }} />
				)}

				{tipText && (
					<Box
						sx={{
							position: "absolute",
							bottom: 60,
							left: 20,
							backgroundColor: "#fff8db",
							border: "2px solid #D4A017",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: "11px",
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
							zIndex: 6,
						}}
						dangerouslySetInnerHTML={{ __html: tipText }}
					/>
				)}
			</Box>

			{footerText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: "13px", color: "#333", fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important` }}>
					{footerText}
				</Box>
			)}
		</Box>
	);
};

Template248.thumbnail = "/images/template-1.png";
export default Template248;
